import React from 'react';
import { motion } from 'framer-motion';

const QuickQuestions = ({ onQuestionClick }) => {
  const questions = [
    {
      id: 1,
      icon: '🗺️',
      title: 'مسیریابی سفر',
      template: 'من الان در لوکیشن _______ هستم و میخوام برم به _______ سریعترین و ارزانترین راه رو بهم پیشنهاد بده'
    },
    {
      id: 2,
      icon: '💱',
      title: 'ارز مسافرتی',
      template: 'روش دریافت ارز مسافرتی از سامانه TRAVEL.ICE.IR چجوریه'
    },
    {
      id: 3,
      icon: '🍽️',
      title: 'رستوران‌ها',
      template: '10 مورد از رستوران های اقتصادی/میان رده/لوکس منطقه _______ بهم معرفی کن'
    },
    {
      id: 4,
      icon: '📅',
      title: 'برنامه سفر',
      template: 'روز اولمه رسیدم به _______ و تعداد _______ شب اقامت دارم یه برنامه سفر برای کل روزهایی که اینجام برام بچین'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 w-full max-w-4xl mx-auto px-4 py-6">
      {questions.map((question, index) => (
        <motion.button
          key={question.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          onClick={() => onQuestionClick(question.template)}
          className="flex items-start gap-3 p-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-blue-500/50 rounded-xl transition-all duration-300 text-right group"
        >
          <div className="text-3xl flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
            {question.icon}
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-white mb-1 group-hover:text-blue-400 transition-colors">
              {question.title}
            </h3>
            <p className="text-xs text-gray-400 line-clamp-2 leading-relaxed">
              {question.template.replace(/_+/g, '...')}
            </p>
          </div>
        </motion.button>
      ))}
    </div>
  );
};

export default QuickQuestions;
